//Config file for 2025 season reefscape

/**
 * The option for QATA Quick Questions
 */
export const gridSettings2025 = {
    "auto": {
        "rc": 4
    },
    "tele": {
        "rc": 4
    }
}
export const qataQuestions2025 = {
    auto: [
        {
            question: 'Start position:',
            options: ['Processor', 'Middle', 'Cage']
        }
    ],
    tele: [
        {
            question: 'Drive Train Speed:',
            options: ['Fast', 'Slow']
        },
        {
            question: 'Coral station intake:',
            options: ['Fast (0-.5s)', 'Medium (0.5s-1s)', 'Slow (1s+)']
        },
        {
            question: 'Alignment w/ reef:',
            options: ['Fast (0-.5s)', 'Medium (0.5-1s)', 'Slow(1s+)']
        },
        {
            question: 'Backside alignment:',
            options: ['Not done', 'Fast(0-.5s)', 'Medium(.5-1s)', 'Slow(1s+)']
        },
        {
            question: 'Driver skill:',
            options: ['Good', 'Average', 'Bad']
        },
        {
            question: 'Climb time:',
            options: [],
            isNumber: true
        }
    ]
};

/**
 * Holds all information for the info page
 * For structure:
 * Title: name of the section
 * Info: array holding the different subsections in the main section
 * Subtitle: Name of the subsection
 * Text: the text in that subsection
 */
export const additionalInfoObject2025 = {
    qata :{
        title: "What is QATA",
        info: [
            {
                subtitle: "What is it?",
                text: (
                    <>
                        QATA refers to data that cannot be expressed with numbers and provides context for quantitative data. 
                        To enter QATA while scouting, press <em>Alt</em> (left) to open a text box, or on mobile, tap the team number area button. For defense notes, press <em>Right Alt</em> or tap <em>Right Shift</em>, or tap the timer.
                    </>
                )
            },
            {
                subtitle: "Examples",
                text: (
                    <>
                        Things to write about in auto include: starting position (middle, proc side, cage side) and reasons for any auto failures.
                        Things to write about in teleop include: drivetrain speed, coral intake speed, alignment with reef speed, ground/hp intake speed,
                         driver skill, and scoring backside of reef capabilities. Additionally writing about any else that occured in the match that gives context
                        is helpful.
                    </>
                )
            }
        ]
    },
    auto_buttons: {
        title: "Data Buttons: Auto",
        info: [
        {
            subtitle: "L1, L2, L3, L4",
            text: (
            <>
                These 4 buttons are the coral scoring buttons, corresponding to
                their respective levels of the reef. The lowest level (the trough)
                is considered L1, while the highest part of the reef is L4.{" "}
                <span style={{ textDecoration: "underline" }}>
                If a robot <span style={{ fontWeight: "bold" }}>misses</span> the
                coral, it does{" "}
                <span style={{ fontWeight: "bold" }}>not</span> count.
                </span>{" "}
                This button will add to the L1, L2, L3, and L4.
            </>
            ),
        },
        {
            subtitle: "L1 Miss, L2 Miss, L3 Miss, L4 Miss",
            text: (
            <>
                When the robot fails to score on its intended scoring target. If the
                missed piece happens to score on an unintended target, add 1 to both
                the miss and the place scored.{" "}
                <span style={{ textDecoration: "underline" }}>
                For instance, if a robot misses L4 but it lands in L1, add 1 to
                both L4 Miss <span style={{ fontWeight: "bold" }}>not</span> L1.{" "}
                count.
                </span>
            </>
            ),
        },
        {
            subtitle: "Algae Proc",
            text: <>When the robot makes the algae it goes into the processor.</>,
        },
        {
            subtitle: "Algae Proc Miss",
            text: (
            <>When the robot does not make the algae go into the processor successfully.</>
            ),
        },
        {
            subtitle: "Algae Net",
            text: <>When a robot places an algae successfully into the net.</>,
        },
        {
            subtitle: "Algae Net Miss",
            text: <>When a robot misses an algae while attempting to place in the net.</>,
        },
        {
            subtitle: "Dealgae",
            text: <>When a robot takes algae off the reef.</>,
        },
        {
            subtitle: "Leave",
            text: (
            <>
                When a robot leaves the starting line in auto.{" "}
                <span style={{ textDecoration: "underline" }}>
                Robot must be off the starting line at the{" "}
                <span style={{ fontWeight: "bold" }}>end</span> of auto{" "}
                to count. If they leave temporarily then return to the start line
                it no longer counts for the point.
                </span>
            </>
            ),
        },
        ],
    },
    tele_buttons: {
        title: "Data Buttons: Teleop",
        info: [
        {
            subtitle: "L1, L2, L3, L4",
            text: (
            <>
                Repeat from the Auto L1, L2, L3, L4, except this button will add to
                the L1, L2, L3, and L4 teleop.
            </>
            ),
        },
        {
            subtitle: "L1 Miss, L2 Miss, L3 Miss, L4 Miss",
            text: (
            <>
                Repeat from the Auto L1 Miss, L2 Miss, L3 Miss, L4 Miss, except this
                button will add to the L1 Miss, L2 Miss, L3 Miss, and L4 Miss
                teleop.
            </>
            ),
        },
        {
            subtitle: "Algae Proc",
            text: <>Repeat from Auto but now in teleop.</>,
        },
        {
            subtitle: "Algae Proc Miss",
            text: (
            <>When the robot does not make the algae go into the processor successfully.</>
            ),
        },
        {
            subtitle: "Algae Net",
            text: <>Repeat from Auto but now in teleop.</>,
        },
        {
            subtitle: "Algae Net Miss",
            text: <>Repeat from Auto but now in teleop.</>,
        },
        {
            subtitle: "Dealgae",
            text: <>When a robot takes algae off the reef.</>,
        },
        {
            subtitle: "Climb Level",
            text: (
            <>
                Climb corresponds to the robot’s endgame state, click to set the
                correct point value: 0 for nothing, 2 for parking under the barge, 6
                for shallow climb, and 12 for deep climb.
            </>
            ),
        },
        {
            subtitle: "Oof Time",
            text: (
            <>
                Oof Time corresponds to how much time the robot spends incapable of
                moving due to a robot error or incapable of scoring due to mechanism
                failure/jamming.{" "}
                <span style={{ fontWeight: "bold" }}>
                (An opposing robot pinning the robot does NOT count as oof time).
                </span>{" "}
                Clicking it will start a stopwatch. When a robot gets back online,
                click to stop the stopwatch.
            </>
            ),
        },
        {
            subtitle: "Defend Time",
            text: (
            <>
                A timer to keep track of when the robot is defending others. Defense
                counts as active disruption in opponents' scoring cycles.
            </>
            ),
        },
        ],
    },
};


/**
 * make sure the stuff in here matches whats in the mainSettings const
 */
export const startScoutPage2025 = {
    match_number :{
        label: "match_number",
        display: "Match Number",
        writeType: "int",
        placeholder: "Current match #",
        maxLength:"999"
    },
    team_number :{
        label: "team_number",
        display: "Team Number",
        writeType: "int",
        placeholder: "# of the team you are scouting",
        maxLength:"13000"
    },
}

/**
 * this is the homepage stuff
 */
export const initialPage2025 = {
    event_path :{
        label: "event_path",
        display: "Event Path",
        writeType: "str",
        placeholder: "The tba event code",
        maxLength:"20"
        
    },
    scout_id :{
        label: "scout_id",
        display: "Scout ID",
        writeType: "str",
        placeholder: "Your Name",
        maxLength:"20"
    },
    scout_team :{
        "label": "scout_team",
        "display": "Scout Team",
        "writeType": "int",
        "placeholder": "The Scouter's Team Number",
        "maxLength":"13000"
        
    },
    team_position : {
        label: "team_position",
        display: "Team Position",
        writeType: "int",
        placeholder: "1, 2, or 3",
        maxLength:"3"
    },
    alliance_color : {
        label: "alliance_color",
        display: "Alliance Color",
        writeType: "str",
        placeholder: "Click to Set Color",
        maxLength:"4"
    }
};

/**
 * Just a little note
 * event_path is hardcoded in both tabs/Home and components/Eventinput
 * scout_team is hardcoded in tabs/Home
 * allaince_color is hardcoded in both tabs/Home and tabs/Scout (for the post match section)
 * 
 * basically dont mess with any of the "start" section datapoints bc it might screw with something somewhere
 * that goes for the ones in initialPage and startScoutPage as well
 * anything else is fair game to change
 */
export const mainSettings2025 = {
    "imported": {
        "transitionMode": "auto"
    },
    "auto": [
        {
            "label": "auto_l4",
            "display": "🪸 L4",
            "trigger": "q",
            "columnStart": 1,
            "columnEnd": 2,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "int"
        },
        {
            "label": "auto_l3",
            "display": "🪸 L3",
            "trigger": "w",
            "columnStart": 1,
            "columnEnd": 2,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "int"
        },
        {
            "label": "auto_l2",
            "display": "🪸 L2",
            "trigger": "e",
            "columnStart": 1,
            "columnEnd": 2,
            "rowStart": 3,
            "rowEnd": 4,
            "writeType": "int"
        },
        {
            "label": "auto_l1",
            "display": "🪸 L1",
            "trigger": "r",
            "columnStart": 1,
            "columnEnd": 2,
            "rowStart": 4,
            "rowEnd": 5,
            "writeType": "int"
        },
        {
            "label": "auto_l4_miss",
            "display": "🧱 L4 Miss",
            "trigger": "a",
            "columnStart": 2,
            "columnEnd": 3,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "int"
        },
        {
            "label": "auto_l3_miss",
            "display": "🧱 L3 Miss",
            "trigger": "s",
            "columnStart": 2,
            "columnEnd": 3,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "int"
        },
        {
            "label": "auto_l2_miss",
            "display": "🧱 L2 Miss",
            "trigger": "d",
            "columnStart": 2,
            "columnEnd": 3,
            "rowStart": 3,
            "rowEnd": 4,
            "writeType": "int"
        },
        {
            "label": "auto_l1_miss",
            "display": "🧱 L1 Miss",
            "trigger": "f",
            "columnStart": 2,
            "columnEnd": 3,
            "rowStart": 4,
            "rowEnd": 5,
            "writeType": "int"
        },
        {
            "label": "auto_algae_processor",
            "display": "🦠 Algae Proc",
            "trigger": "u",
            "columnStart": 3,
            "columnEnd": 4,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "int"
        },
        {
            "label": "auto_algae_processor_miss",
            "display": "💊 Algae Proc Miss",
            "trigger": "i",
            "columnStart": 4,
            "columnEnd": 5,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "int"
        },
        {
            "label": "auto_algae_net",
            "display": "🦠 Algae Net",
            "trigger": "o",
            "columnStart": 3,
            "columnEnd": 4,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "int"
        },
        {
            "label": "auto_algae_net_miss",
            "display": "💊 Algae Net Miss",
            "trigger": "p",
            "columnStart": 4,
            "columnEnd": 5,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "int"
        },
        {
            "label": "auto_dealgae",
            "display": "🧼 Dealgae",
            "trigger": "j",
            "columnStart": 3,
            "columnEnd": 5,
            "rowStart": 3,
            "rowEnd": 4,
            "writeType": "int"
        },
        {
            "label": "leave",
            "display": "🍶 Leave",
            "trigger": "k",
            "columnStart": 3,
            "columnEnd": 5,
            "rowStart": 4,
            "rowEnd": 5,
            "writeType": "bool"
        }
    ],
    "tele": [
        {
            "label": "tele_l4",
            "display": "🪸 L4",
            "trigger": "q",
            "columnStart": 1,
            "columnEnd": 2,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "int"
        },
        {
            "label": "tele_l3",
            "display": "🪸 L3",
            "trigger": "w",
            "columnStart": 1,
            "columnEnd": 2,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "int"
        },
        {
            "label": "tele_l2",
            "display": "🪸 L2",
            "trigger": "e",
            "columnStart": 1,
            "columnEnd": 2,
            "rowStart": 3,
            "rowEnd": 4,
            "writeType": "int"
        },
        {
            "label": "tele_l1",
            "display": "🪸 L1",
            "trigger": "r",
            "columnStart": 1,
            "columnEnd": 2,
            "rowStart": 4,
            "rowEnd": 5,
            "writeType": "int"
        },
        {
            "label": "tele_l4_miss",
            "display": "🧱 L4 Miss",
            "trigger": "a",
            "columnStart": 2,
            "columnEnd": 3,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "int"
        },
        {
            "label": "tele_l3_miss",
            "display": "🧱 L3 Miss",
            "trigger": "s",
            "columnStart": 2,
            "columnEnd": 3,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "int"
        },
        {
            "label": "tele_l2_miss",
            "display": "🧱 L2 Miss",
            "trigger": "d",
            "columnStart": 2,
            "columnEnd": 3,
            "rowStart": 3,
            "rowEnd": 4,
            "writeType": "int"
        },
        {
            "label": "tele_l1_miss",
            "display": "🧱 L1 Miss",
            "trigger": "f",
            "columnStart": 2,
            "columnEnd": 3,
            "rowStart": 4,
            "rowEnd": 5,
            "writeType": "int"
        },
        {
            "label": "tele_algae_processor",
            "display": "🦠 Algae Proc",
            "trigger": "u",
            "columnStart": 3,
            "columnEnd": 4,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "int"
        },
        {
            "label": "tele_algae_processor_miss",
            "display": "💊 Algae Proc Miss",
            "trigger": "i",
            "columnStart": 4,
            "columnEnd": 5,
            "rowStart": 1,
            "rowEnd": 2,
            "writeType": "int"
        },
        {
            "label": "tele_algae_net",
            "display": "🦠 Algae Net",
            "trigger": "o",
            "columnStart": 3,
            "columnEnd": 4,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "int"
        },
        {
            "label": "tele_algae_net_miss",
            "display": "💊 Algae Net Miss",
            "trigger": "p",
            "columnStart": 4,
            "columnEnd": 5,
            "rowStart": 2,
            "rowEnd": 3,
            "writeType": "int"
        },
        {
            "label": "tele_dealgae",
            "display": "🧼 Dealgae",
            "trigger": "j",
            "columnStart": 3,
            "columnEnd": 4,
            "rowStart": 3,
            "rowEnd": 4,
            "writeType": "int"
        },
        {
            "label": "climb_level",
            "display": "🪜 Climb Level",
            "trigger": "k",
            "columnStart": 4,
            "columnEnd": 5,
            "rowStart": 3,
            "rowEnd": 4,
            "writeType": "cycG",
            "cycGOptions": [0, 2, 6, 12]

        },
        {
            "label": "defending_time",
            "display": "🛡️ Defend Time",
            "trigger": "n",
            "columnStart": 3,
            "columnEnd": 4,
            "rowStart": 4,
            "rowEnd": 5,
            "writeType": "inc"
        },
        {
            "label": "oof_time",
            "display": "🚑 Oof Time",
            "trigger": "m",
            "columnStart": 4,
            "columnEnd": 5,
            "rowStart": 4,
            "rowEnd": 5,
            "writeType": "inc"
        }

    ],

    "after": [

        {
            "label": "auto_qata",
            "display": "Auto QATA",
            "writeType": "str",
            "placeholder": "e.g. speed? path? starting location?"
        },
        {
            "label": "qata",
            "display": "Tele QATA",
            "writeType": "str",
            "placeholder": "e.g. how are they scoring? speed? skill?"
        },
        {
            "label": "defense_qata",
            "display": "Defense QATA",
            "writeType": "str",
            "placeholder": "how did they play defense? push power? speed?"
        }
    ],
    "start": [
        {
            "label": "scout_id",
            "display": "Scout ID",
            "writeType": "str",
            "placeholder": "Your Name",
            "maxLength":"20"
        },
        {
            "label": "scout_team",
            "display": "Scout Team",
            "writeType": "int",
            "placeholder": "The scouter's team number",
            "maxLength":"13000"
        },
        {
            "label": "team_position",
            "display": "Team Position",
            "writeType": "int",
            "placeholder": "1, 2, or 3",
            "maxLength":"3"
        },
        {
            "label": "match_number",
            "display": "Match Number",
            "writeType": "int",
            "placeholder": "Current match #",
            "maxLength":"999"
        },
        {
            "label": "team_number",
            "display": "Team Number",
            "writeType": "int",
            "placeholder": "# of the team you are scouting",
            "maxLength":"13000"
        },
        {
            "label": "alliance_color",
            "display": "Alliance Color",
            "writeType": "str",
            "placeholder": "Click to Set Color",
            "maxLength":"4"
        }
    ]
}